// import { Card, InputGroup, Spinner } from 'react-bootstrap';
// import Button from 'react-bootstrap/Button';
// import Form from 'react-bootstrap/Form';
// import  '../../assets/Login.css';
// import { useNavigate } from 'react-router-dom';
// import { useDispatch,useSelector} from 'react-redux';
// import { authLogin } from '../../state/action/authAction';
// import { useState,useEffect } from 'react';
// import ErrorMessage from '../../component/messagecomponent/errorMessage';
// import { ExclamationCircleOutlined, EyeInvisibleOutlined, EyeOutlined } from '@ant-design/icons';
// import loginImg from "../../assets/images/logo-2 (1).png"


// function Login() {
//   const navigate=useNavigate()
//   const dispatch = useDispatch();
//   const [error, setError] = useState(false)
//   const [isLoading,setIsLoading]=useState(false);
//   const [showPassword, setShowPassword] = useState(false);
//   const [candidate, setCandidate] = useState({
//     email: '', // Make sure to initialize all required fields
//     password:''
//   });
//   // const [accessToken, setAccessToken] = useState('');
//   const loginState = useSelector(state => state?.user?.authReducer);
//   const [credError,setCredError]=useState('');
//  const a= useSelector((state)=>state?.user?.authReducer?.loginError);
//  console.log(a,"kkk");


  
//   const handleChange = (e) => {
//     setCredError('');
//     console.log(e.target.value, "jkjkjj");
//     try {
//       setCandidate({
//         ...candidate,
//         [e.target.name]: e.target.value,
//       });
//     } catch (error) {
//       console.log(error);
//     }
//   }


//   const handleLogin = async (event) => {
 
//     event.preventDefault();
//        if (candidate?.email === "" ) {
//       setCredError("Enter Email");
//     }else if(candidate?.password === ""){
//       setCredError("Enter Password")
//     }else{
   
//       setCredError('');
//     const user = {
//       email: candidate.email,
//       password: candidate.password
//     };

//     try {
//       setIsLoading(true);
//        dispatch(authLogin(user));
//        setIsLoading(false);
//     } catch (error) {
//       console.error("API Request Error:", error);
//     }
//   }
//   };

//   // useEffect(() => {
//   //   setCredError(a);
//   //   if (loginState.loginSuccess === true) {
//   //     window.location.reload();

//   //     navigate('/document');
//   //   } else if (loginState.loginError != null) {
  
//   //   }
//   // }, [loginState.loginSuccess,loginState.loginError,navigate,a]);


//   useEffect(() => {
//     console.log("ddddd",loginState);
//     if (loginState?.loginSucess === "Sucess") {
//       // setErr(false);
//       setCredError("");
//       // window.location.reload();
//       setIsLoading(false);
//       navigate("/document");
//     } else if (loginState?.loginError === null) {
//       // setErr(false);
//       setCredError('');
//       setIsLoading(false);
//     } else if (loginState?.loginError != null) {
 
//       const errorMessage = loginState?.loginError;
//       // setErr(true);
//         setCredError(errorMessage);
//       setIsLoading(false);
//     } 
//     else{
//       // setErr(false);
//       setCredError("");
    
//     }
//   }, [loginState]);




//   return (
//     <div className='Bkgcolor'  style={{display:"flex",justifyContent:"center",alignItems:"center"}}>
//    {/* <ErrorMessage message={credError || ''}/> */}
//     <Card >
//     <Card.Body>
//     {credError ? <div style={{ display: 'flex', alignItems: 'center', justifyContent: 'center', background: 'lightgrey', padding: '10px' }}>
//     <ExclamationCircleOutlined style={{ color: 'red', marginRight: '10px',fontSize:'23px' }} />
//     <p style={{ color: 'red', margin: 0,fontWeight:'500' }}>{credError}</p>
//   </div>:null}
//     <Form >
//     <Form.Group className="mb-3" controlId="formBasicImage" style={{display:'flex',flexDirection:'row',justifyContent:'center'}}>
//       <img  src={loginImg}  width={"40%"}/>
//       </Form.Group>
//       <Form.Group className="mb-3" controlId="formBasicEmail">
//         <Form.Label style={{fontWeight:'500'}}>Email address</Form.Label>
//         <Form.Control
//           type="email"
//           name="email" 
//           value={candidate.email}
//           onChange={handleChange} 
//           placeholder="Enter email"
//         />
//       </Form.Group>

//       <Form.Group className="mb-3" controlId="formBasicPassword">
//   <Form.Label style={{ fontWeight: '500' }}>Password</Form.Label>
//   <InputGroup>
//     <Form.Control
//       type={showPassword ? 'text' : 'password'}
//       name="password"
//       value={candidate.password}
//       onChange={handleChange}
//       placeholder="Password"
//     />
//     <InputGroup.Text id="inputGroup-sizing-sm">
//     { showPassword ? (
//         <EyeOutlined
//           style={{ cursor: 'pointer' }}
//           onClick={() => setShowPassword(!showPassword)}
//         />
//       ) : (
//         <EyeInvisibleOutlined
//           style={{ cursor: 'pointer' }}
//           onClick={() => setShowPassword(!showPassword)}
//         />
//       )
// }
//     </InputGroup.Text>

//   </InputGroup>
// </Form.Group>


      
//       <div style={{display:"flex", flexDirection:"center",justifyContent:"center",alignItems:"center"}}>
//       <Button style={{backgroundColor:'#3F113C',border:'1px solid #3F113C',paddingLeft:'10%',paddingRight:'10%',borderRadius:'20px'}} type="submit" onClick={handleLogin}> 
//       {isLoading ?
//       <Spinner animation="border" role="status">
//       <span className="visually-hidden">Loading...</span>
//     </Spinner>
//     :
//  'Login'
//       }

// </Button>
//       </div>
//       <div  style={{display:'flex',justifyContent:"flex-end",alignItems:"center"}} className='account'>
//       {/* <Button variant="link" onClick={()=>navigate('/')}>Dont have account?</Button> */}
//       </div>

//     </Form>

//     </Card.Body>
//   </Card>
//    </div>


//   );
// }

// export default Login;


import { Card, InputGroup, Spinner } from "react-bootstrap";
import Button from "react-bootstrap/Button";
import Form from "react-bootstrap/Form";
import "../../assets/Login.css";
import { useNavigate } from "react-router-dom";
import { useDispatch, useSelector } from "react-redux";
import { authLogin } from "../../state/action/authAction";
import { useState, useEffect } from "react";
import { ExclamationCircleOutlined, EyeInvisibleOutlined, EyeOutlined } from "@ant-design/icons";
import loginImg from "../../assets/images/logo-2 (1).png";

function Login() {
  const navigate = useNavigate();
  const dispatch = useDispatch();
  const [isLoading, setIsLoading] = useState(false);
  const [showPassword, setShowPassword] = useState(false);
  const [credError, setCredError] = useState("");

  const [candidate, setCandidate] = useState({
    email: "",
    password: "",
  });

  const loginState = useSelector((state) => state?.user?.authReducer);

  const handleChange = (e) => {
    setCredError("");
    setCandidate({
      ...candidate,
      [e.target.name]: e.target.value,
    });
  };

  const handleLogin = async (event) => {
    event.preventDefault();
    if (candidate.email === "") {
      setCredError("Enter Email");
    } else if (candidate.password === "") {
      setCredError("Enter Password");
    } else {
      setCredError("");
      setIsLoading(true);
      dispatch(authLogin({ email: candidate.email, password: candidate.password }));
      setIsLoading(false);
    }
  };

  useEffect(() => {
    if (loginState?.loginSucess === "Sucess") {
      setCredError("");
      setIsLoading(false);
      navigate("/document");
    } else if (loginState?.loginError) {
      setCredError(loginState?.loginError);
      setIsLoading(false);
    }
  }, [loginState, navigate]);

  return (
    <div className="d-flex justify-content-center align-items-center vh-100 Bkgcolor" >
      <Card style={{ width: "400px", padding: "20px", boxShadow: "0px 4px 10px rgba(0,0,0,0.2)", borderRadius: "10px" }}>
        <Card.Body>
          {credError && (
            <div className="d-flex align-items-center justify-content-center bg-light p-2 rounded mb-3">
              <ExclamationCircleOutlined style={{ color: "red", marginRight: "10px", fontSize: "20px" }} />
              <p className="text-danger m-0 fw-bold">{credError}</p>
            </div>
          )}

          <Form onSubmit={handleLogin}>
            <div className="text-center mb-3">
              <img src={loginImg} alt="Login" width="50%" />
            </div>

            <Form.Group className="mb-3">
              <Form.Label className="fw-bold">Email address</Form.Label>
              <Form.Control type="email" name="email" value={candidate.email} onChange={handleChange} placeholder="Enter email" />
            </Form.Group>

            <Form.Group className="mb-3">
              <Form.Label className="fw-bold">Password</Form.Label>
              <InputGroup>
                <Form.Control type={showPassword ? "text" : "password"} name="password" value={candidate.password} onChange={handleChange} placeholder="Password" />
                <InputGroup.Text onClick={() => setShowPassword(!showPassword)} style={{ cursor: "pointer" }}>
                  {showPassword ? <EyeOutlined /> : <EyeInvisibleOutlined />}
                </InputGroup.Text>
              </InputGroup>
            </Form.Group>

            <div className="d-flex justify-content-center">
              <Button type="submit" style={{ backgroundColor: "#3F113C", border: "none", borderRadius: "20px", padding: "10px 40px" }}>
                {isLoading ? <Spinner animation="border" size="sm" /> : "Login"}
              </Button>
            </div>
          </Form>
        </Card.Body>
      </Card>
    </div>
  );
}

export default Login;
